module.exports = __webpack_public_path__ + "static/media/mohercliff.67c45d1f.jpg";